
export const toWordCase = (str: string): string => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const toSentenceCase = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatCityName = (city: string): string => {
  if (!city) return '';
  return city.toLowerCase() === 'slc' ? 'Salt Lake City' : toWordCase(city);
};
